import React, { useContext, useEffect, useState } from 'react'
import { HouseholdChangeContext } from '../HouseholdContext/HouseholdChangeContext';
import CheckboxConfirm from 'components/StraightThroughVehicleComp/2_Confirm/ConfirmBody/CheckboxConfirm';
import ValidationModal from 'components/ValidationModal';
import HouseholdChangeBtnNav from '../HouseholdChangeBtnNav/HouseholdChangeBtnNav';
import Note from 'components/StraightThroughAddressComp/Note/Note';
import DriverHHM_ConfirmForm from './DriverHHM_ConfirmForm';
import { DriverHHMContextComp } from '../HouseholdContext/DriverHHMContext';
import DriverAssignmentConfirm from 'components/StraightThroughVehicleComp/2_Confirm/ConfirmBody/DriverAssignmentConfirm';
import monthsDOB from '../CustomInputs/StateObjects/Months';

export const HouseholdConfirm_SaveContext = React.createContext();

const ChangeHouseholdConfirm_Main = () => {
    const context = useContext(HouseholdChangeContext);
    const [isLargeScreen, setIsLargeScreen] = useState(false);
    const [confirmChanges, setConfirmChanges] = useState(false);

    // Update state based on window size
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setIsLargeScreen(true);
            } else {
                setIsLargeScreen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const saveConfirmCheckbox = (value) => {
        setConfirmChanges(value);

        var classCopy = context["householdChangeClass"];
        classCopy.confirmation = value;
    }

    const displayHouseholdChanges = () => {
        if (context?.householdChangeClass?.driversHHMs?.drivers?.newDrivers?.length > 0)
            return true;
        else if (context?.householdChangeClass?.driversHHMs?.householdMembers?.newMembers?.length > 0)
            return true;
        else if (context?.householdChangeClass?.driversHHMs?.drivers?.storedDrivers?.some(driver => driver.componentTracker && Object.keys(driver.componentTracker).length > 0)) // Update Drivers
            return true;
        else if (context?.householdChangeClass?.driversHHMs?.householdMembers?.storedMembers?.some(member => member.componentTracker && Object.keys(member.componentTracker).length > 0))
            return true;
        return false;
    }

    // Helper function to convert month name to month index
    const monthNameToIndex = (monthName) => {
        const months = monthsDOB
        return months.indexOf(monthName);
    };

    // Calculates the age of the driver on changes of the dob fields
    const calculateAge = (dobMonth, dobDay, dobYear) => {
        const today = new Date();
        const birthMonthIndex = monthNameToIndex(dobMonth);
        const birthDate = new Date(dobYear, birthMonthIndex, dobDay);
        let age = today.getFullYear() - dobYear;
        const monthDifference = today.getMonth() - birthDate.getMonth();

        // Adjust age if the birthday hasn't happened yet this year
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dobDay)) {
            age--;
        }
        return age;
    };

    const displayDriverAssignment = () => {
        var storedMembers = context?.householdChangeClass?.driversHHMs?.householdMembers?.storedMembers?.filter(member => member?.editType !== "");
        // Added driver form completed
        if (context?.householdChangeClass?.driversHHMs?.drivers?.newDrivers?.length > 0) return true;
        // Added household member as a driver
        else if (context?.householdChangeClass?.driversHHMs?.householdMembers?.newMembers?.length > 0 &&
            calculateAge(context?.householdChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.userInfo?.dobMonth, context?.householdChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.userInfo?.dobDay, context?.householdChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.userInfo?.dobYear) >= 16 &&
            context?.householdChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.driverInfo?.ownInsurance === "0")
            return true;
        // Updated household member "As a Driver"
        else if (storedMembers?.some((member) => member?.componentTracker === "Update HHM" && member?.editType === "Add as driver on policy.")) return true;
        else return false;
    }

    return (
        <>
            <DriverHHMContextComp>
                {/* Changes of Drivers/Household Member Section */}
                {displayHouseholdChanges() &&
                    <>
                        <DriverHHM_ConfirmForm
                            context={context}
                            isLargeScreen={isLargeScreen}
                        />
                    </>
                }

                {/* Driver Assignment Section */}
                {displayDriverAssignment() &&
                    <>
                        <hr className='less-margin' />
                        <div className='mx-0 mx-sm-5'>
                            <div className='mx-sm-3'>
                                <DriverAssignmentConfirm
                                    vehReqContext={HouseholdChangeContext}
                                    reqVehicleClass={"householdChangeClass"}
                                />
                            </div>
                        </div>
                        <hr className='less-margin' />
                    </>
                }
                <HouseholdConfirm_SaveContext.Provider
                    value={{
                        saveConfirmCheckbox,
                        confirmChanges
                    }}
                >
                    <CheckboxConfirm styles={styles} requestType={"Household"} />
                </HouseholdConfirm_SaveContext.Provider>

                <hr />
                <Note />
                <hr />

                <HouseholdChangeBtnNav />
            </DriverHHMContextComp>

            <ValidationModal
                title={context.validationTitle}
                show={context.showModal}
                handleClose={() => context.setShowModal(false)}
                validationMsg={context.validationMsg}
            />
        </>
    )
}

const styles = {
    checkboxContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingRight: '0'
    }
}

export default ChangeHouseholdConfirm_Main